import { Injectable } from '@angular/core';
import { ScalingService } from './scaling.service';
import { GroupService } from './group.service';

@Injectable({
  providedIn: 'root'
})
export class StandaloneService {

  screenWidth = window.screen.availWidth || window.screen.width || 1024;
  screenHeight = window.screen.availHeight || window.screen.height || 768;
  windowSizeRatio = 0.5;

  constructor(
    private scalingService: ScalingService,
    private groupService: GroupService,
  ) { }

  fitDeviceInGuestScreen(device) {
    const screen = {
      scaler: this.scalingService.coordinator(device.display.width, device.display.height),
      rotation: device.display.rotation,
      bounds: {
        x: 0,
        y: 0,
        w: this.screenWidth,
        h: this.screenHeight
      }
    };

    const projectedSize = screen.scaler.projectedSize(
      screen.bounds.w * this.windowSizeRatio,
      screen.bounds.h * this.windowSizeRatio,
      screen.rotation
    );

    return projectedSize;
  }

  open(device) {
    const url = '#!/c/' + (device.serial ? device.serial : '') + '?standalone';

    const projected = this.fitDeviceInGuestScreen(device);

    const features = [
      'width=' + projected.width,
      'height=' + projected.height,
      'top=' + (this.screenHeight / 4),
      'left=' + (this.screenWidth / 5),
      'toolbar=no',
      'location=no',
      'dialog=yes',
      'personalbar=no',
      'directories=no',
      'status=no',
      'menubar=no',
      'scrollbars=no',
      'copyhistory=no',
      'resizable=yes'
    ].join(',');

    const newWindow = window.open(url, 'STF-' + device.serial, features);

    this.setWindowTitle(newWindow, device);

    newWindow.onbeforeunload = () => {
      // TODO: check for usage
      this.groupService.kick(device).then(() => {
        // $rootScope.$digest()
      });

      // TODO: save coordinates
      // $scope.controlWindowWidth = windowOpen.innerWidth
      // $scope.controlWindowHeight = windowOpen.innerHeight
      // $scope.controlWindowTop = windowOpen.screenTop
      // $scope.controlWindowLeft = windowOpen.screenLeft
    };

    // TODO: Resize on-demand
    // newWindow.onresize = function (e) {
    //   let windowWidth =  e.target.outerWidth
    //   let windowHeight =  e.target.outerHeight
    //
    //   let newWindowWidth = Math.floor(projected.width * windowHeight / projected.height)
    //   newWindow.resizeTo(newWindowWidth, windowHeight)
    // }
  }

  setWindowTitle(newWindow, device) {
    let windowTitle = 'STF - ' + device.name;
    if (device.name !== device.model) {
      windowTitle += ' (' + device.model + ')';
    }
    // windowTitle += ' (' + device.serial + ')'

    if (newWindow.document) {
      newWindow.document.title = windowTitle;
    }

    setTimeout(() => {
      if (newWindow.document) {
        newWindow.document.title = windowTitle;
      }
    }, 400);
  }
}
